export const LISTEN_INTERVAL = 10000
export const SOUND_SPEED = 1
export const DEFAULT_VOLUME = 1.0
